import { Circle } from './Circle';
import { Dot } from './Dot';
import { Dots } from './Dots';
import { Grid } from './Grid';

export const Loader = {
  Circle,
  Dot,
  Dots,
  Grid,
};
